import React from 'react';
import FadeLoader from 'react-spinners/FadeLoader'

interface Props {
    size?:'small'|'big', 
    backgroundColor?:string, 
    color?:string, 
    loadingText:string
}

/**
 * A spinner conform to the look & feel of other paymentus spinners such as those used in ROTP.
 */
export class SpinnerOverlay extends React.Component<Props, {}> {
        
    render(){
        const overlayStyle:React.CSSProperties = {
                                height: '100vh',
                                width: '100vw',
                                position:'fixed',
                                top: 0, // top and left are needed when ui flow running inside CP or AD
                                left: 0, 
                                zIndex: 10000,
                                margin: '-20px',
                                backgroundColor: this.props.backgroundColor || 'rgba(0,0,0,0.8)'
                            };
        let loaderSize = 40;
        if(this.props.size === 'small'){
            loaderSize = 20;
        }

        return(     
            <div className="d-flex flex-column align-items-center justify-content-center"  style={overlayStyle}>
                    <FadeLoader radius={loaderSize} color={this.props.color || 'white'} loading={true} />
                    <div style={{color: this.props.color || 'white'}}>{this.props.loadingText || ''}</div>
            </div>
        )

    }
}
